<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新建物料
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog custom-class="new-material" :title="!mid ? '新建物料' : '编辑物料'" :visible.sync="dialogShow" width="600px" :close-on-click-modal="false" :modal-append-to-body="false">

    <div v-loading="loading" style="width: 480px; margin: 0px auto 20px">
      <el-form ref="materialForm" :model="material" :rules="materialRules" label-position="left" label-width="120px">
        <el-form-item label="物料编码" prop="material_no">
          <el-row>
            <el-col :span="11">
              <el-input v-model="material.material_no" clearable />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="名称" prop="material_title">
          <el-input v-model="material.material_title" clearable placeholder="请输入" />
        </el-form-item>

        <el-form-item label="规格型号">
          <el-input v-model="material.model" clearable placeholder="请输入" />
        </el-form-item>

        <el-form-item label="库存数量">
          <el-row>
            <el-col :span="8">
              <el-input v-model="material.stock_left" type="number" :min="0" placeholder="数量" />
            </el-col>
            <el-col :span="8" :offset="1">
              <el-input v-model="material.stock_unit" clearable placeholder="单位" />
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="物料类型" prop="type">
          <el-radio-group v-model="material.type">
            <el-radio :label="1">原材料</el-radio>
            <el-radio :label="2">半成品</el-radio>
            <el-radio :label="3">成品</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="存放位置" prop="schemeid">
          <qc-scheme-selector v-model="process.schemeid" placeholder="请选择" />
        </el-form-item> -->

        <el-form-item label="备注信息" prop="remark">
          <el-input v-model="material.remark" :rows="3" type="textarea" clearable />
        </el-form-item>

      </el-form>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button plain class="extend" @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" class="extend" @click="submit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getMaterialApi, postMaterialApi, precreateMaterialNoApi } from '@/api/mm/materialApi'

export default {
  name: 'NewStation',

  components: {
    // EmEquipSelector: () => import('@/views/em/components/EmEquipSelector')
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    mid: {
      type: Number,
      default: 0
    },

  },

  data() {
    return {
      loading: false,
      material: {
        material_no: '',
        mid: null,
        material_title: '',
        model: '',
        stock_left: '',
        stock_unit: '',
        type: 0,
        remark: ''
      },
      materialRules: {
        material_no: [
          { required: true, message: '物料编码不能为空', trigger: 'blur' }
        ],
        material_title: [
          { required: true, message: '物料名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '物料类型不能为空', trigger: 'change' }
        ]
      },
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    if (this.mid) this.fetchData()
    if (!this.mid) this.fetchNo()
  },

  methods: {
    fetchData() {
      this.loading = true
      getMaterialApi({mid: this.mid}).then(res => {
        this.loading = false
        if (!res.errno) {
          this.material = Object.assign({}, res.data)
        }
      })
    },

    fetchNo() {
      this.loading = true
      precreateMaterialNoApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.material.material_no = res.data
        }
      })
    },

    submit() {
      this.$refs['materialForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          postMaterialApi(this.material).then(res => {
            this.loading = false
            if (!res.errno) {
              this.$emit('success')
              this.$message.success('物料提交成功')
              this.dialogShow = false
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.new-material {

}
</style>
